import adminReducer from "@/components/access/admin/ducks/reducer"
import userReducer from "@/components/access/ducks/reducer"
import internalReducer from "@/components/access/internal/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const accessReducer = combineReducers({
  internal: internalReducer,
  admin: adminReducer,
  user: userReducer,
})

export default accessReducer
